// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.businessEstablishmentChoice {
  background-color: #f3f4f6;
  padding: 5% 0;
  height: 100%;
}
.businessEstablishmentChoice .pageHeader {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 42px;
  line-height: 53px;
  text-align: center;
  color: #292d31;
}
.businessEstablishmentChoice .searchRow {
  display: flex;
  align-items: space-between;
  width: 40%;
  min-width: 761px;
  margin: auto;
  margin-top: 42px;
}
.businessEstablishmentChoice .searchRow .searchWrapper {
  width: 374px;
  height: 55px;
  border-bottom: 2px solid #292d31;
  padding: 14.5px 16px 14.5px 0;
}
.businessEstablishmentChoice .searchRow .searchWrapper .searchImageWrapper {
  display: inline-block;
  position: relative;
  top: 5px;
  margin-right: 5px;
}
.businessEstablishmentChoice .searchRow .searchWrapper input {
  border: none;
  background-color: #f3f4f6;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  color: #c1c1c1;
  width: 324px;
}
.businessEstablishmentChoice .searchRow .searchWrapper input:focus-visible {
  outline: none;
  color: black;
}
.businessEstablishmentChoice .searchRow button {
  margin-left: auto;
  background-color: rebeccapurple;
  display: inline-block;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 6px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #505054;
  display: inline-block;
  padding-left: 2px;
  padding-right: 2px;
  width: 103px;
  height: 34px;
}
.businessEstablishmentChoice .searchRow button .buttonImage {
  display: inline-block;
  margin-right: 4px;
  position: relative;
  top: 2px;
}
.businessEstablishmentChoice .searchRow button .grayButtonText {
  display: inline-block;
}
.businessEstablishmentChoice .businessCardContainer {
  margin: 60px auto 0;
  width: 45%;
  min-width: 844px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-left: 30px;
}`, "",{"version":3,"sources":["webpack://./src/screens/businessEstablishmentChoice/business-establishment-choice.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,aAAA;EACA,YAAA;AACJ;AAAI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAER;AACI;EACI,aAAA;EACA,0BAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AACR;AACQ;EACI,YAAA;EACA,YAAA;EACA,gCAAA;EACA,6BAAA;AACZ;AAAY;EACI,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;AAEhB;AACY;EACI,YAAA;EACA,yBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AAChB;AACY;EACI,aAAA;EACA,YAAA;AAChB;AAGQ;EACI,iBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AADZ;AAGY;EACI,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AADhB;AAGY;EACI,qBAAA;AADhB;AAKI;EACI,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AAHR","sourcesContent":[".businessEstablishmentChoice {\n    background-color: #f3f4f6;\n    padding: 5% 0;\n    height: 100%;\n    .pageHeader {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 42px;\n        line-height: 53px;\n        text-align: center;\n        color: #292d31;\n    }\n\n    .searchRow {\n        display: flex;\n        align-items: space-between;\n        width: 40%;\n        min-width: 761px;\n        margin: auto;\n        margin-top: 42px;\n\n        .searchWrapper {\n            width: 374px;\n            height: 55px;\n            border-bottom: 2px solid #292d31;\n            padding: 14.5px 16px 14.5px 0;\n            .searchImageWrapper {\n                display: inline-block;\n                position: relative;\n                top: 5px;\n                margin-right: 5px;\n            }\n\n            input {\n                border: none;\n                background-color: #f3f4f6;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 18px;\n                line-height: 26px;\n                color: #c1c1c1;\n                width: 324px;\n            }\n            input:focus-visible {\n                outline: none;\n                color: black;\n            }\n        }\n\n        button {\n            margin-left: auto;\n            background-color: rebeccapurple;\n            display: inline-block; \n            background: #ffffff;\n            border: 1px solid #e1e1e1;\n            border-radius: 6px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 18px;\n            text-align: center;\n            color: #505054;\n            display: inline-block;\n            padding-left: 2px;\n            padding-right: 2px;\n            width: 103px;\n            height: 34px;\n\n            .buttonImage {\n                display: inline-block;\n                margin-right: 4px;\n                position: relative;\n                top: 2px;\n            }\n            .grayButtonText {\n                display: inline-block;\n            }\n        }\n    }\n    .businessCardContainer {\n        margin: 60px auto 0;\n        width: 45%;\n        min-width: 844px;\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        padding-left: 30px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
